import { axiosInstance } from "../../config/api/AxiosConfig";

export async function themeLoader({ request, themeParam } = {}) {
  // Use themeParam if provided directly, otherwise check request or window.location
  let companyId = themeParam;

  if (!companyId) {
    const url = request ? new URL(request.url) : new URL(window.location.href);
    companyId = url.searchParams.get("slug");
  }

  if (!companyId) return null;
  try {
    const response = await axiosInstance.get(
      `/company/branding/slug/${companyId}`,
    );
    console.log("theme response=>", response);
    return response;
  } catch (err) {
    console.error("theme error=>", err);
    return null;
  }
}
